import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {InjectedRouter} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {IndigoFooter} from './IndigoFooter';
import { IndigoHeader} from './IndigoHeader';
import {CampusFeedback} from '../FlatPages/CampusFeedback';
import {WhyIndigo} from './WhyIndigo';
import {IndigoSlider} from './IndigoSlider';

// URL-safe Base64 decoder function
const urlSafeBase64Decode = (str: string): string => {
    console.log('urlSafeBase64Decode input:', str);
    
    // First, handle URL encoding if present
    let decoded = decodeURIComponent(str);
    console.log('After URL decode:', decoded);
    
    // Replace URL-safe characters back to standard Base64
    decoded = decoded.replace(/-/g, '+').replace(/_/g, '/');
    console.log('After URL-safe conversion:', decoded);
    
    // Add padding if needed to make length a multiple of 4
    while (decoded.length % 4) {
        decoded += '=';
    }
    console.log('After padding:', decoded);
    
    try {
        // Decode using standard atob()
        const result = atob(decoded);
        console.log('Final decoded result:', result);
        console.log('Result length:', result.length);
        return result;
    } catch (error) {
        console.error('Error decoding Base64:', error);
        console.log('Failed to decode:', decoded);
        // If URL-safe Base64 fails, try regular Base64
        try {
            return atob(str);
        } catch (error2) {
            console.error('Regular Base64 also failed:', error2);
            throw error;
        }
    }
};

const homepageStyle : React.CSSProperties = {
    width:'100%',
    backgroundColor:'#F7F5F0'

}
const designBox: React.CSSProperties = {
    backgroundRepeat:'no-repeat',
    backgroundPosition:'center',
    backgroundSize:'cover',
    display:'inline-block',
    height:'250px',
    width:'350px',
    marginRight:'18px',
}
const designBox1 = Object.assign({}, designBox, {backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Patern1.jpg') + ')'});
const designBox3 = Object.assign({}, designBox, {backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Pattern3.jpg') + ')'});

const designBox2: React.CSSProperties = {
    backgroundRepeat:'no-repeat',
    backgroundSize:'cover',
    display:'inline-block',
    height:'250px',
    width:'350px',
    marginRight:'18px',
    backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/smallslide1.png') + ')',
    cursor:'pointer'
}

const underSlider: React.CSSProperties = {
    display:'flex',
    justifyContent:'center',
    flexDirection:'row',
    marginBottom:'86px',
    flexWrap:'wrap'
}
const bottomImg: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl('~/images/IndigoLowerImage.jpg') + ')',
    backgroundRepeat:'no-repeat',
    backgroundPosition:'center',
    backgroundSize:'cover',
    width:'100%',
    height:'461px',
    margin:'40px auto',
    ':hover': {
        backgroundColor:'#A6A6A6'
    }
}
const lines:React.CSSProperties = {
    width:'980px',
    borderBottom:'1px solid #EEEDED',
    margin:'15px auto'
}
const processText: React.CSSProperties = {
    fontFamily:'Reitam',
    fontSize:'24px',
    marginBottom:'0px',
    marginTop:'25px'
}
const underProcess: React.CSSProperties = {
    fontFamily:'Reitam',
    fontSize:'24px',
    marginTop:'0px',
    marginBottom:'10px'
    
}
const moreApparel: React.CSSProperties = {
    fontFamily:'AveriaSerifLightItalic',
    display:'inline-block',
    letterSpacing:'0.2em',
    color:'#616060',
    fontSize:'18px',
    cursor:'pointer'
}

const moreApparelBox: React.CSSProperties = {
    textAlign:'right',
    marginRight:'222px',
    marginTop:'60px'
}

const appArrow: React.CSSProperties = {
    width:'2%',
    display:'inline-block',
    marginBottom:'2px'
}

const browseStyle: React.CSSProperties = {
    margin:'50px auto 0px auto'
}
const startedBtn: React.CSSProperties = {
    width:'210px',
    height:'39px',
    cursor:'pointer',
    fontFamily:'Reitam',
    backgroundColor:'#E69043',
    textAlign:'center',
    color:'white',
    lineHeight:'2.3em',
    fontSize:'17px',
    position:'relative',
    zIndex:5,
    top:'50px',
    left:'245px'
}
const BottomDiv: React.CSSProperties = {
    backgroundColor:'#FFFFFF',
    height:'192px',
    width:'395px',
    position:'relative',
    textAlign:'center',
    top:'30%',
    opacity:.6,
    left:'150px',
}
const textCustom: React.CSSProperties = {
    display:'flex',
    flexDirection:'column'
}


class Props extends Tgcc.BaseProps{
    ActiveProof: Tgcc.Proof;
}

class _IndigoHome extends React.Component <Props, any > {
    state = {
        homepage:""
    }

    componentWillMount(){
        if(this.props.location.query.u && this.props.location.query.c){
            console.log('Raw URL parameters:', {
                u: this.props.location.query.u,
                c: this.props.location.query.c
            });
            
            var decodedEmail = urlSafeBase64Decode(this.props.location.query.u);
            
            // Convert spaces back to + characters in the token (URL encoding issue)
            var rawToken = this.props.location.query.c.replace(/ /g, '+');
            console.log('Raw token being sent to backend:', rawToken);
            
            console.log('Values being sent:', {
                email: decodedEmail,
                token: rawToken,
                tokenLength: rawToken.length
            });
            
            this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.ResetPassword, payload: {token: rawToken, email: decodedEmail}}});
        }
    }

    componentDidMount(){
        var tag = document.getElementById('homepage');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    setError = (msg: string) => {
        this.setState({error: msg, isWaiting: false}, () => {
            this.scrollPageToView("TopProofError");
        });
        return false;
    }
    openProofEdit = () => {
        if(this.props.state.LoginData && this.props.state.UserInfo){
            browserHistory.push(Tgcc.Routes.IndigoProofEdit)
        }
        else {
            browserHistory.push(Tgcc.Routes.IndigoRegister)
        }    
    };
    openProducts = () =>{browserHistory.push(Tgcc.Routes.IndigoProductListView)}
    openAbout = () =>{browserHistory.push(Tgcc.Routes.About)}
    
  
    render() {
        return (
                <div style={homepageStyle}>
                    <div id="homepage"></div>
                    <IndigoHeader />
                    <CampusFeedback state={this.props.state} />

                    <IndigoSlider />
                    <WhyIndigo />          
                        <div style={moreApparelBox} className='campusAppBox'>
                            <div style={moreApparel} onClick={this.openProducts} className='seeMoreApp'>SEE MORE APPAREL HERE</div>
                            <img style={appArrow} src={Tgcc.ResolveUrl('~/images/arrow.png')} className='campusArrow'/>
                        </div>
                        <div style={bottomImg} key={1}>
                            <div style={BottomDiv}>
                                <div style={textCustom}>
                                    <h6 style={processText}>Custom Resort, Giftshop,</h6>
                                    <h6 style={underProcess}> and Destination Apparel</h6>
                                </div>
                            </div>
                            <div onClick={this.openProofEdit} style={startedBtn}>Get Started</div>

                        </div>
                        
                        <IndigoFooter state={this.props.state} />

                </div>
        );
    }
}


var radiumIndigoPage = Radium(_IndigoHome);

const mapStateToProps = (state: Tgcc.GlobalState) => { 
    return { ActiveProof: state.ActiveProof,
             state:state}
};
export var IndigoHome = connect(mapStateToProps)(radiumIndigoPage);



